import React, { useState } from 'react';
import CustomPagination from '../../components/CustomPagination';
import useLiveDataTable from '../../hooks/useLiveDataTable';
import { useGetJobQuery, useGetJobStatisQuery, useRemoveJobMutation } from '../../redux/services/JobService';
import { deleteConfirmation } from '../../utils';
import JobsAddModal from '../JobsPage/AddModal';
import JobsViewodal from '../JobsPage/ViewModal';

const DriverJobs = ({ id }) => {
    const {
        currentPage,
        perPage,
        q,
        searchQuery,
        setSearchQuery,
        handlePageChange,
        handlePerPageChange,
        handleSearchChange,
        onSearchKeyHandler,
        handleSearchBy,
        searchBy,
    } = useLiveDataTable();
    const [isShow, setIsShow] = useState(false)
    const [isEdit, setIsEdit] = useState(null)
    const [isView, setIsView] = useState(false)


    const [removeRequest] = useRemoveJobMutation()



    const { data: data3, } = useGetJobStatisQuery(id)
    const { data: data2, isLoading, isFetching, refetch } = useGetJobQuery({ id: id, pagination: `?page=${currentPage}&perPage=${perPage}&search_by=${searchBy}&search=${q}` })
    const statistic = data3?.response?.data
    const jobs = data2?.response?.data?.data
    const total = data2?.response?.data?.total;


    const handleEdit = (items) => {
        setIsEdit(items)
        setIsShow(true)
    }

    const handleView = (items) => {
        setIsEdit(items)
        setIsView(true)
    }

    return (
        <>
            <div className="single-data mt-2">
                {/* <h5 className="text-left">Jobs</h5> */}
                <div class="single-data mt-2">
                    <h4 class="text-left mb-4">Total Trips</h4>
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-primary tx-fixed-white card-bg-img">
                                <a class="card-body text-decoration-none position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Total Trips</p>
                                        </div><span class="fs text-white">{statistic?.total?.total} - ${statistic?.total?.amount || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-success tx-fixed-white card-bg-img">
                                <a class="card-body position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Monthly Trips</p>
                                        </div><span class="fs text-white">{statistic?.monthly?.total} - ${statistic?.monthly?.amount || 0} </span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-6 col-md-6">
                            <div class="card bg-warning tx-fixed-white card-bg-img">
                                <a class="card-body position-relative d-flex justify-content-between">
                                    <div>
                                        <div class="flex-grow-1">
                                            <p class="mb-4 fs-18 fw-semibold text-white">Weekly Trips</p>
                                        </div><span class="fs text-white">{statistic?.weekly?.total} - ${statistic?.weekly?.amount || 0}</span>
                                    </div>
                                    <div class="min-w-fit-content"><span class="avatar avatar-xxl bg-transparent"><img src="https://seatsaver.io/6.png" class="op-7" alt="img" /></span></div>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="row">
                    <div className="col-auto ms-auto">
                        <button className="btn bg-light text-capitalize">
                            Search By: <span className='text-success'>{searchBy?.split('_').join(' ')}</span>
                        </button>
                    </div>
                    <div className="col-lg-3 col-5 p-0 mb-3">
                        <div className="input-group m-0">
                            <input
                                className="form-control" type="text" placeholder="Search Here..."
                                aria-describedby="basic-addon1"
                                value={searchQuery}
                                onKeyUp={(e) => onSearchKeyHandler(e)}
                                onChange={(e) => setSearchQuery(e.target?.value)}
                            />
                            <span
                                type="button"
                                onClick={() => handleSearchChange(searchQuery)}
                                className="input-group-text bg-transparent border text-primary" id="basic-addon1">
                                <i className="ri-search-line" />
                            </span>
                        </div>
                    </div>
                </div>


                <CustomPagination
                    isFetching={isFetching}
                    data={jobs}
                    total={total}
                    onChangePage={handlePageChange} // Handle page change
                    onChangeRowsPerPage={handlePerPageChange} // Handle per page change
                    paginationDefaultPage={currentPage} // Set the current page

                    columns={[
                        {
                            name: 'ID',
                            selector: row => row.id,
                            sortable: true,
                            width: '70px'
                        },
                        {
                            selector: row => row?.driver?.full_name,
                            sortable: true,
                            name: (
                                <span
                                    onClick={() => handleSearchBy('driver_name')}
                                >
                                    {searchBy == 'driver_name' ? <b className='text-success'>Driver Name</b> : 'Driver Name'}
                                </span>
                            )
                        },
                        {
                            name: 'Job Amount ($)',
                            selector: row => row.job_amount,
                            sortable: true,
                        },
                        {
                            name: 'Job Date',
                            selector: row => row.job_date,
                            sortable: true,
                        },

                        {
                            name: 'Hourly Job Payment Rate ($)',
                            selector: row => row.hourly_rate,
                            sortable: true,
                        },
                        {
                            selector: row => row.broker_details,
                            sortable: true,
                            name: (
                                <span
                                    onClick={() => handleSearchBy('broker_details')}
                                >
                                    {searchBy == 'broker_details' ? <b className='text-success'>Broker Detail</b> : 'Broker Detail'}
                                </span>
                            )
                        },
                        {
                            selector: row => row.c_number,
                            sortable: true,
                            name: <span onClick={() => handleSearchBy('c_number')}>C-Number</span>
                        },
                        {
                            name: 'Job Detail',
                            selector: row => row.job_details,
                            sortable: true,
                        },
                        {
                            name: 'Actions',
                            cell: (row, i) => {
                                return (
                                    <div className="hstack gap-1 fs-1">
                                        <button
                                            aria-label="view"
                                            onClick={() => handleView(row)}
                                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-eye-fill" />
                                        </button>
                                        <button
                                            aria-label="edit"
                                            // onClick={() => navigate(`/jobs/edit/${row?.id}`, { state: { isEdit: row } })}
                                            onClick={() => handleEdit(row)}
                                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-edit-line" />
                                        </button>
                                        <a
                                            aria-label="delete"
                                            onClick={() => deleteConfirmation(() => removeRequest(row?.id))}
                                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                                        >
                                            <i className="ri-delete-bin-7-line" />
                                        </a>
                                    </div>
                                )
                            },
                            ignoreRowClick: true,
                            allowOverflow: true,
                            button: true,
                            width: '220px'
                        },
                    ]}
                />
            </div>



            {isShow && (
                <JobsAddModal
                    show={isShow}
                    handleClose={() => {
                        setIsShow(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}

            {isView && (
                <JobsViewodal
                    show={isView}
                    handleClose={() => {
                        setIsView(false)
                        setIsEdit(null)
                    }}
                    isEdit={isEdit}
                />
            )}
        </>
    )
}

export default DriverJobs